import styled from "styled-components"
interface IAutomationCentreWrapperProps {
	$lang: "ar" | "en"
}
export const AutomationCentreWrapper = styled.div<IAutomationCentreWrapperProps>`
	width: 33%;
	height: 100dvh;
	position: absolute;
	left: ${(props) => (props.$lang === "ar" ? 0 : "auto")};
	right: ${(props) => (props.$lang === "en" ? 0 : "auto")};
	top: 0;
	overflow: hidden;
	overflow-y: scroll;
	background-color: #fff;
	padding: 24px;
	z-index: 1000;
	.backAction {
		margin-bottom: 24px;
		display: flex;
		justify-content: flex-end;
		align-items: center;
		cursor: pointer;
		> div {
			display: flex;
			justify-content: center;
			align-items: center;
			color: #435363;
			width: 30px;
			height: 30px;
			font-size: 20px;
		}
	}
	form {
		width: 100%;
		.containerFormElements {
			display: flex;
			flex-direction: column;
			gap: 24px;
		}
	}
`
